
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 2h16v16.844a3.019 3.019 0 01-2.375 2.938L16 23.438v3.563c0 1.645-1.355 3-3 3s-3-1.355-3-3v-10.75l-.75.188c-.156.203-.224.331-.625.625-.642.47-1.633.938-2.969.938C4.23 18.004 3 16.712 3 15.096v-.406l.281-.313L10 7.596V2.002zm2 2v3h12V4H12zm-.594 5l-6.313 6.406c.082.421.255.594.563.594.903 0 1.459-.273 1.813-.531s.438-.438.438-.438l.188-.344.406-.125 2.25-.594 1.25-.313v13.344c0 .565.435 1 1 1s1-.435 1-1v-5.188l.781-.188 8.438-1.781c.467-.1.781-.523.781-1V8.998H11.407z"}})])
          )
        }
      }
    